import request from '@/utils/request';

/**
 * 未读汇总（HeaderBar 铃铛角标）
 *
 * 服务端唯一口径：前端只渲染返回值，不做本地加减。
 */
export function getUnreadSummary() {
    return request.http<Message.ISummary>({
        url: '/chsMessage/getUnreadSummary.json',
        method: 'POST',
        data: {}
    });
}

/**
 * 会话列表分页（通知中心左侧列表）
 *
 * 返回分页对象（PageModel：result / totalCount），故泛型用通用映射类型，
 * 由调用方（store）按 `result.result` / `result.totalCount` 读取。
 */
export function getConversationList(data: { pageNo?: number; pageSize?: number }) {
    return request.http<Record<string, any>>({
        url: '/chsMessage/getConversationList.json',
        method: 'POST',
        data
    });
}

/**
 * 会话内消息分页（通知中心右侧消息流）
 */
export function getChatMessageList(data: { conversationId: string; pageNo?: number; pageSize?: number }) {
    return request.http<Record<string, any>>({
        url: '/chsMessage/getMessageList.json',
        method: 'POST',
        data
    });
}

/**
 * 标记某会话已读（独立接口，不复用 updateStatus）
 */
export function markConversationRead(data: { conversationId: string }) {
    return request.http<number>({
        url: '/chsMessage/markRead.json',
        method: 'POST',
        data
    });
}

/**
 * 全部已读
 */
export function markAllMessageRead() {
    return request.http<number>({
        url: '/chsMessage/markAllRead.json',
        method: 'POST',
        data: {}
    });
}